import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLoadingService } from './global-loading.service';

@Component({
  selector: 'app-global-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="loading$ | async" class="global-spinner" role="status" aria-live="polite" aria-label="Loading">
      <div class="spinner-border" aria-hidden="true"></div>
    </div>
  `,
  styles: [`.global-spinner { position:fixed; inset:0; display:flex; align-items:center; justify-content:center; background:rgba(0,0,0,0.25); z-index:2000; } .spinner-border { width:2rem; height:2rem; border:.25em solid rgba(0,0,0,0.1); border-top-color:#007bff; border-radius:50%; animation:spin .75s linear infinite; } @keyframes spin { to { transform: rotate(360deg); } }`]
})
export class GlobalSpinnerComponent {
  loading$;
  constructor(private loadingService: GlobalLoadingService) { this.loading$ = this.loadingService.loading$; }
}
